import React from 'react';
import {
  GestureResponderEvent,
  TouchableWithoutFeedback,
} from 'react-native';
import { Box, Inline } from '@styleseat/ui';
import { colors } from '@styleseat/brand';
import { BodyText } from '../../../ui';
import { BasicSearchIcon } from '../../../ui/Icons';
import analytics from '../../../../modules/analytics';

const SearchPopoverTrigger = ({ onOpen }) => {
  React.useEffect(() => {
    analytics.track('client_search_popover_trigger_viewed');
  }, []);

  const handleOpenPress = React.useCallback((event: GestureResponderEvent) => {
    event.preventDefault();
    onOpen();
  }, [onOpen]);

  return (
    <TouchableWithoutFeedback onPress={handleOpenPress}>
      <Inline
        padding={8}
        color={colors.whiteWash}
      >
        <Box paddingRight={4}>
          <BasicSearchIcon
            width={20}
            height={20}
          />
        </Box>
        <BodyText color={colors.silver}>Service, Stylist or Salon</BodyText>
      </Inline>
    </TouchableWithoutFeedback>
  );
};

export default SearchPopoverTrigger;
